export default __webpack_public_path__ + "static/media/pantry1-afterI-1920w.f4ec5fa6.avif";